import { AbstractModel } from '@uzurv/core';
import { DriverBankTransactionReason } from './driver-bank-transaction-reason';
import { DriverBankTransactionType } from './driver-bank-transaction-type';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class DriverBankTransaction extends AbstractModel {
  @autoserialize
  amount: number;

  @autoserialize
  description: string;

  @autoserialize
  driverBankId: number;

  @autoserializeAs(DriverBankTransactionReason)
  driverBankTransactionReason: DriverBankTransactionReason;

  @autoserializeAs(DriverBankTransactionType)
  driverBankTransactionType: DriverBankTransactionType;
}
